module.exports = __webpack_public_path__ + "img/tn.9a6a802b.png";